import { ProgramTypeEnum } from '../../Enum/ProgramTypeEnum';

export enum OnboardingDashboardCardType {
    MonthlyGoal = 'MonthlyGoal',
    CompletedMonthToDate = 'CompletedMonthToDate',
    NeededToday = 'NeededToday',
    NeededForRestOfMonth = 'NeededForRestOfMonth',
    ScheduledToday = 'ScheduledToday',
    ConversionRateMonthToDate = 'ConversionRateMonthToDate',
    UpcomingAppointmentsThisMonth = 'UpcomingAppointmentsThisMonth',
    UpcomingAppointmentsNextMonth = 'UpcomingAppointmentsNextMonth',
    RescheduledThisMonth = 'RescheduledThisMonth',
    NeedsReschedule = 'NeedsReschedule',
    CallsMadeToday = 'CallsMadeToday',
    UndocumentedOnboards = 'UndocumentedOnboards'
}

export interface IOnboardingDashboardDetail {
    Id?: string;
    ProviderId?: string;
    ProviderName?: string;
    MemberId?: string;
    MemberName?: string;
    AhcccsId?: string;
    Month?: number;
    MonthName?: string;
    Year?: number;
    GoalCount?: number;
    MonthlyGoal?: number;
    CompletedCount?: number;
    RemainingGoal?: number;
    ConversionRateMonthToDate?: number | null;
    AppointmentsRequired?: number | null;
    UpcomingScheduledMembers?: number;
    NeededForRestOfMonth?: number | null;
    SchedulingConversionRate?: number | null;
    SchedulingConversionYear?: number | null;
    SchedulingConversionMonth?: number | null;
    CompletedDate?: string;
    AppointmentDate?: string;
    AppointmentTime?: string;
    ScheduledDate?: string;
    PreviousAppointmentDate?: string;
    RescheduledDate?: string;
    CallDate?: string;
    CallCount?: number;
    Status?: string;
    TeamName?: string;
    RegionName?: string;
    ProgramType?: ProgramTypeEnum;
    ProgramName?: string;
    CallTime?: string;
    PopulationName?: string;
    PopulationNumber?: number;
    PhoneString?: string;
}

export interface IOnboardingDashboardDetailFilterOption {
    Id: string;
    Name: string;
}